export default "__VITE_ASSET__Cpty8oZx__"